import { createAction, props } from '@ngrx/store';

import { IFormMode } from '../../types/IFormMode';
import { Transaction } from '../../../core/domain/transaction/transaction';

export const openTransactionModal = createAction(
  '[Transaction Modal] Open Modal',
  props<{ mode: IFormMode; transaction?: Transaction }>()
);

export const closeTransactionModal = createAction(
  '[Transaction Modal] Close Modal'
);
